export default __webpack_public_path__ + "static/media/ALL_ACCOR_PLUS_Logo_BLACK_Vertical.17a89be3.png";